import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Typography, Button, Paper, CircularProgress, Box } from '@mui/material';
import ContentDetailPage from '../components/content/ContentDetailPage';
import { useOrganization } from '../context/OrganizationContext';

const ContentDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { currentTeamId, isLoading } = useOrganization();

  if (!id) {
    return (
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h5" gutterBottom>
            Invalid Content ID
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            No content ID was provided in the URL.
          </Typography>
          <Button variant="contained" onClick={() => navigate('/dashboard')}>
            Back to Dashboard
          </Button>
        </Paper>
      </Container>
    );
  }

  // Wait for the org/team context to finish re-hydrating from the API before
  // deciding whether a team is selected. Without this, a hard refresh shows
  // "No Team Selected" for the brief moment before React Query completes.
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 300 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!currentTeamId) {
    return (
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h5" gutterBottom>
            No Team Selected
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            Please select a team from the dashboard to view content.
          </Typography>
          <Button variant="contained" onClick={() => navigate('/dashboard')}>
            Back to Dashboard
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <ContentDetailPage
      contentId={id}
      onClose={() => navigate('/content')}
    />
  );
};

export default ContentDetail;